export enum DataSource {
  TEMPLATE = 'template',
  DOCTOR = 'doctor'
}
